import React from "react";
import "./DeleteConfirmModal.css";

function DeleteConfirmModal({
  isOpen,
  onClose,
  onConfirm,
  itemName,
  itemType = "recruit",
  warningMessage,
}) {
  if (!isOpen) return null;

  const getDefaultWarning = () => {
    switch (itemType) {
      case "list":
        return "This action cannot be undone. The list will be permanently removed, but the recruits in this list will remain in your pipeline.";
      case "recruit":
      default:
        return "This action cannot be undone. All history and documents associated with this recruit will be permanently removed.";
    }
  };

  const getTitle = () => {
    switch (itemType) {
      case "list":
        return "Delete List";
      case "recruit":
      default:
        return "Delete Recruit";
    }
  };

  const getButtonText = () => {
    switch (itemType) {
      case "list":
        return "Delete List";
      case "recruit":
      default:
        return "Delete Recruit";
    }
  };

  return (
    <div className="delete-confirm-overlay" onClick={onClose}>
      <div
        className="delete-confirm-content"
        onClick={e => e.stopPropagation()}
      >
        <div className="delete-confirm-header">
          <span className="material-icons delete-icon">warning</span>
          <h2>{getTitle()}</h2>
        </div>

        <div className="delete-confirm-body">
          <p>
            Are you sure you want to delete <strong>{itemName}</strong>?
          </p>
          <p className="delete-warning">
            {warningMessage || getDefaultWarning()}
          </p>
        </div>

        <div className="delete-confirm-footer">
          <button className="btn btn-secondary" onClick={onClose}>
            Cancel
          </button>
          <button className="btn btn-danger" onClick={onConfirm}>
            <span className="material-icons">delete</span>
            <span>{getButtonText()}</span>
          </button>
        </div>
      </div>
    </div>
  );
}

export default DeleteConfirmModal;
